import { DEFAULT_FLAGS, FLAGS_GB, GB_LANGUAGE_CODE, FLAGS_BRASIL, BR_LANGUAGE_CODE } from "../../consts";

const useFlags = (language: string) => {
  if (language === GB_LANGUAGE_CODE) return FLAGS_GB;
  if (language === BR_LANGUAGE_CODE) return FLAGS_BRASIL;

  return DEFAULT_FLAGS;
};

export default useFlags;
